import { createSlice } from "@reduxjs/toolkit";

const initialState = {
     activeButton: "All",
};

const skillSlice = createSlice({
     name: "skill",
     initialState,
     reducers: {
          updateTargetButton(state, actions) {
               state.activeButton = actions.payload;
          },
     },
});

export const skillAction = skillSlice.actions;
export default skillSlice.reducer;
